import React from "react";
import { makeStyles } from "@material-ui/core";

function AutoFormItemLayout ( props ) {

    const { children, column, ...others } = props;

    const useStyles = makeStyles ( ( theme ) => ( {

        root: {
    
            // margin: theme.spacing(1),
            margin: "1%",
            width: column ? ( column.width || '45%' ) : '45%',
    
        },
    
      } ) );
    
    const classes = useStyles ();

    const styledProps = {

        className: classes.root,
        ...others

    };

    return (
        <>
        {
            children &&
            React.Children.map ( children, ( ( child ) => (
                    React.isValidElement ( child )
                    ?
                    React.cloneElement( child, styledProps )
                    :
                    child
            ) ) )

        }
        </>
    );
}

export default AutoFormItemLayout;
